import React, { useEffect } from "react";
import "./Team.css";
import AOS from "aos";
import "aos/dist/aos.css";

import teamMemberImage from "../images/avatar.jpeg";
import teamMemberImage1 from "../images/1.webp";
import teamMemberImage2 from "../images/2.webp";
import teamMemberImage4 from "../images/4.webp";
import teamMemberImage5 from "../images/5.webp";
import teamMemberImage8 from "../images/8.webp";
import teamMemberImage10 from "../images/10.webp";
import teamMemberImage11 from "../images/11.webp";
import teamMemberImage12 from "../images/12.webp";
import teamMemberImage14 from "../images/14.webp";
import teamMemberImage15 from "../images/15.webp";
import teamMemberImage16 from "../images/16.webp";
import teamMemberImage17 from "../images/17.webp";
import teamMemberImage18 from "../images/18.webp";
import teamMemberImage19 from "../images/19.webp";
import teamMemberImage24 from "../images/24.webp";
import teamMemberImage25 from "../images/25.webp";

const teamMembers = [
  {
    name: "Nikhil Kumar",
    description: "IIT Guwahati",
    image: teamMemberImage1,
  },
  { name: "Vivek Kumar", description: "IIT Guwahati", image: teamMemberImage2 },
  {
    name: "Sunny Priyadarshi",
    description: "IIT Guwahati",
    image: teamMemberImage,
  },
  { name: "Ashish Akash", description: "IIT Dharwad", image: teamMemberImage4 },
  { name: "Sonu Kumar", description: "IIT Bhu", image: teamMemberImage5 },
  { name: "Ujjwal Anand", description: "IIT Patna", image: teamMemberImage },
  { name: "Sumit Kumar", description: "IIT Roorkee", image: teamMemberImage },
  { name: "Harsh Anand", description: "IIT Goa", image: teamMemberImage8 },
  { name: "Neetin Kumar", description: "NIT Jaipur", image: teamMemberImage },
  {
    name: "Anwer Sayeed",
    description: "NIT Durgapur",
    image: teamMemberImage10,
  },
  {
    name: "Tasneem Kaushar",
    description: "NIT Silchar",
    image: teamMemberImage11,
  },
  {
    name: "Sourav Kumar Jha",
    description: "NIT Warangal",
    image: teamMemberImage12,
  },
  {
    name: "Vishal Kr. Pandey",
    description: "NIT Raipur",
    image: teamMemberImage,
  },
  {
    name: "Bhanu Prakash",
    description: "IIT Jammu",
    image: teamMemberImage14,
  },
  {
    name: "Runu Sukeerti",
    description: "NIT Arunachal Pradesh",
    image: teamMemberImage15,
  },
  {
    name: "Pranav Kr. Dev",
    description: "NDA (All India Rank 65)",
    image: teamMemberImage16,
  },
  {
    name: "Divyansh Kumar",
    description: "IIT Pune",
    image: teamMemberImage17,
  },
  {
    name: "Riya Anand",
    description: "IIT Patna",
    image: teamMemberImage18,
  },
  {
    name: "Keshav Kumar",
    description: "NIT Patna",
    image: teamMemberImage19,
  },
  {
    name: "Tarun Bhaskar Anand",
    description: "IIEST Shibpur",
    image: teamMemberImage,
  },
  {
    name: "Shiv Shakti Kumar",
    description: "PICT Pune",
    image: teamMemberImage,
  },
  {
    name: "Ritik Kumar",
    description: "NIT Hamirpur",
    image: teamMemberImage,
  },
  {
    name: "Rohit Kumar",
    description: "NIT Allahabad",
    image: teamMemberImage,
  },
  {
    name: "Aniket Kumar",
    description: "NIT Silchar",
    image: teamMemberImage24,
  },
  {
    name: "Rachit Raj",
    description: "NIT Agartala",
    image: teamMemberImage25,
  },
  {
    name: "Rishav Kumar",
    description: "NIT Surat",
    image: teamMemberImage,
  },
  {
    name: "Manish Kumar",
    description: "NIT Agartala",
    image: teamMemberImage,
  },
  {
    name: "Dolly Kumari",
    description: "NIT Kolkata",
    image: teamMemberImage,
  },
  {
    name: "Manohar Kumar",
    description: "NIT Jamshedpur",
    image: teamMemberImage,
  },
  {
    name: "Ayan Choudhary",
    description: "Indian Navy",
    image: teamMemberImage,
  },
];

const Team = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);
  return (
    <section className="team">
      <h2 data-aos="fade-up">Our Star Performers</h2>
      <div className="container team__container">
        {teamMembers.map((member, index) => (
          <article
            key={index}
            className="team__member"
            data-aos="fade-up"
            data-aos-delay={`${index * 50}`}
          >
            <div className="team__member-image">
              <img src={member.image} alt={`${member.name}`} />
            </div>
            <div className="team__member-info">
              <h4>{member.name}</h4>
              <p>{member.description}</p>
            </div>

            {index === teamMembers.length - 1 && (
              <div className="team__member-socials" data-aos="fade-up">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://instagram.com"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a target="_blank" rel="noreferrer" href="https://twitter.com">
                  <i className="fab fa-twitter"></i>
                </a>
                <a target="_blank" rel="noreferrer" href="https://linkedin.com">
                  <i className="fab fa-linkedin"></i>
                </a>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default Team;
